"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.984 11.78H1.016V5h13.968v6.78ZM.753 4h14.495c.414 0 .752.332.752.74v7.299a.748.748 0 0 1-.752.741H.753A.748.748 0 0 1 0 12.039V4.74C0 4.332.338 4 .753 4Zm8.096 7.068c-.263 0-.542-.025-.77-.105-.436-.2-1.093-.663-1.16-1.666h-.571v-.75h.558v-.408h-.558v-.75h.58c.107-.906.667-1.32 1.149-1.502.583-.222 1.552-.013 1.66.012l-.17.73c-.347-.078-.955-.144-1.216-.042-.375.142-.581.405-.651.802h1.269v.75H7.668v.408h1.3v.75h-1.28c.045.45.267.782.682.973.268.094.884.042 1.2-.015l.138.737a5.213 5.213 0 0 1-.858.076Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M22.869 17.25H1.131V6.375h21.738V17.25Zm-21.93-12h22.123c.517 0 .938.42.938.934V17.44c0 .515-.42.934-.938.934H.939A.938.938 0 0 1 0 17.441V6.184c0-.515.421-.934.939-.934Zm12.302 10.555c-.398 0-.819-.039-1.162-.16-.662-.306-1.687-1.035-1.743-2.642H9.327v-.938h1v-.895h-1v-.937h1.025c.13-1.45.989-2.102 1.727-2.385.88-.337 2.361-.014 2.527.024l-.21.914c-.52-.118-1.519-.24-1.978-.064-.665.256-1.02.762-1.11 1.51h2.122v.938h-2.161v.895h2.16v.938h-2.145c.039.83.418 1.434 1.153 1.776.516.18 1.591.051 1.957-.015l.17.922a8.055 8.055 0 0 1-1.323.119Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M30.492 23H1.508V8.5h28.984V23ZM1.252 7h29.497C31.439 7 32 7.559 32 8.245v15.01a1.25 1.25 0 0 1-1.251 1.245H1.252A1.25 1.25 0 0 1 0 23.255V8.245A1.25 1.25 0 0 1 1.252 7Zm16.402 14.073c-.53 0-1.091-.051-1.548-.213-.883-.408-2.25-1.38-2.324-3.523h-1.346v-1.25h1.333v-1.193h-1.333v-1.25h1.367c.172-1.933 1.318-2.802 2.302-3.18 1.173-.45 3.149-.018 3.37.032l-.281 1.219c-.693-.158-2.024-.32-2.637-.085-.887.34-1.359 1.016-1.479 2.014h2.828v1.25h-2.881v1.193h2.881v1.25h-2.861c.052 1.108.558 1.912 1.538 2.368.688.24 2.121.069 2.609-.02l.226 1.23a10.74 10.74 0 0 1-1.764.158Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M46.118 35.489H1.882V13.125h44.236v22.364ZM1.693 11.25h44.614c.933 0 1.693.757 1.693 1.688v22.738c0 .93-.76 1.688-1.694 1.688H1.694A1.692 1.692 0 0 1 0 35.675V12.937c0-.93.76-1.687 1.694-1.687ZM24.395 32.4l-.208-.056c-2.513-1.006-3.688-2.752-3.797-5.598h-1.831V24.87h1.81v-1.242h-1.81v-1.875h1.81v-.051c0-3.254 2.02-4.528 3.78-5.273 1.898-.83 4.714-.147 5.028-.066l-.468 1.816c-.683-.174-2.7-.517-3.814-.03-1.679.712-2.645 1.52-2.645 3.553v.05h4.581v1.876H22.25v1.242h4.581v1.875h-4.563c.087 2.023.794 3.098 2.52 3.817 2.102.294 3.906-.19 3.924-.195l.505 1.806c-.068.02-1.313.36-3.02.36-.56 0-1.168-.036-1.802-.133Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M61.491 47.318H2.509V17.5h58.982v29.818ZM2.258 15h59.484A2.256 2.256 0 0 1 64 17.25v30.318a2.256 2.256 0 0 1-2.258 2.25H2.258A2.256 2.256 0 0 1 0 47.568V17.25A2.256 2.256 0 0 1 2.258 15Zm30.268 28.201-.278-.076c-3.351-1.34-4.917-3.669-5.062-7.464h-2.442v-2.5h2.413v-1.656h-2.413v-2.5h2.413v-.068c0-4.339 2.693-6.037 5.04-7.03 2.53-1.106 6.286-.196 6.705-.088l-.624 2.421c-.911-.232-3.6-.689-5.086-.039-2.238.948-3.527 2.025-3.527 4.736v.068h6.109v2.5h-6.11v1.656h6.11v2.5h-6.085c.116 2.697 1.059 4.131 3.36 5.09 2.803.391 5.208-.253 5.232-.26l.674 2.408c-.091.025-1.751.48-4.027.48-.746 0-1.557-.049-2.402-.178Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconBillingPaymentEuro = function IconBillingPaymentEuro(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Billing Payment Euro' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "BillingPaymentEuro"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconBillingPaymentEuro.sizes = [16, 24, 32, 48, 64];
IconBillingPaymentEuro.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconBillingPaymentEuro;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/global/BillingPaymentEuro.js
// module id = 2051
// module chunks = 0